export const COMPANY_NAME = "RouteMe Software";
export const DEFAULT_PAGINATION_SIZE = 10;
export const SCREEN_SIZES = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

export const DEFAULT_SERVICE_OPTIONS = [
  { label: "Regular Maintenance", value: "regular-maintenance" },
  { label: "Special Service", value: "special-service" },
];
